import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-block form-buttons" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["onClick"]

import { onMounted, reactive, ref } from "vue";
import axios from "axios";
import { uniq } from "lodash";
import {
  getCustomTasks,
  createCustomTasks,
} from "@/services/customTasksService";
import type {
  APICustomTask,
  APIPostCustomTaskPayload,
} from "@/services/customTasksService";
import CustomTaskForm, {
  FormState,
  FormErrors,
} from "@/components/CustomTaskForm.vue";

interface APIErrorsObject {
  non_field_errors?: string[];
}

type APITaskErrors = string[][] | APIErrorsObject;

interface APIValidationErrors {
  midterm_tasks?: APITaskErrors;
  end_of_term_tasks?: APITaskErrors;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTasks',
  props: {
    provisionalCohortId: {},
    prevUrl: {},
    nextUrl: {}
  },
  setup(__props: any) {

const props = __props;



const tasks = reactive<FormState>({
  midterm_tasks: [],
  end_of_term_tasks: [],
});

const errors = ref<FormErrors>({
  midterm_tasks: [],
  end_of_term_tasks: [],
});

const toFormState = (customTasks: APICustomTask): FormState => {
  return {
    midterm_tasks: customTasks.midterm_tasks || [],
    end_of_term_tasks: customTasks.end_of_term_tasks || [],
  };
};

const toPayload = (formData: FormState): APIPostCustomTaskPayload => ({
  midterm_tasks: formData.midterm_tasks,
  end_of_term_tasks: formData.end_of_term_tasks,
});

const toFormTaskErrors = (taskErrors: APITaskErrors | undefined): string[] => {
  if (!taskErrors) {
    return [];
  } else if (Array.isArray(taskErrors)) {
    return uniq(taskErrors.flat());
  } else if (taskErrors.non_field_errors) {
    return taskErrors.non_field_errors;
  } else {
    return [];
  }
};

const toFormErrors = (apiErrors: APIValidationErrors): FormErrors => ({
  ...apiErrors,
  midterm_tasks: toFormTaskErrors(apiErrors?.midterm_tasks),
  end_of_term_tasks: toFormTaskErrors(apiErrors?.end_of_term_tasks),
});

const saveCustomTasks = async () => {
  try {
    const data = toPayload(tasks);
    await createCustomTasks(props.provisionalCohortId, data);
    window.location.href = props.nextUrl;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response) {
      const validationErrors = err.response.data as APIValidationErrors;
      errors.value = toFormErrors(validationErrors);
    } else {
      throw err;
    }
  }
};

onMounted(async () => {
  const apiTasks = await getCustomTasks(props.provisionalCohortId);
  const newTasks = toFormState(apiTasks);
  tasks.midterm_tasks = newTasks.midterm_tasks || [];
  tasks.end_of_term_tasks = newTasks.end_of_term_tasks || [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CustomTaskForm, {
      modelValue: tasks,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tasks) = $event)),
      errors: errors.value
    }, null, 8, ["modelValue", "errors"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "btn",
        href: _ctx.prevUrl
      }, " Back ", 8, _hoisted_2),
      _createElementVNode("button", {
        class: "btn btn-burg",
        onClick: _withModifiers(saveCustomTasks, ["prevent"])
      }, " Next ", 8, _hoisted_3)
    ])
  ]))
}
}

})